import React from 'react'
import { Switcher } from "."

export const SwitchItem = ({ title }) => {
    const [check, setCheck] = React.useState(false)

    return title ? (
        <li className='flex-start' >  <div><Switcher w={40} h={20} d={15} check={check} setCheck={setCheck} /> </div> <p onClick={() => setCheck(!check)} > {title} </p></li>
    ) : <></>
}